import { styled } from '@mui/material';

import Button from '../../components/Button';

export const IconButton = styled(Button)(({ theme }) => ({
  color: theme.palette.grey[500],
  borderRadius: theme.shape.borderRadius,
  '&.active': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}));
